var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column-view",class:{
    disabled: _vm.disabled,
    flipped:
      _vm.columnConfiguration &&
      _vm.columnConfiguration.jibCrane &&
      _vm.columnConfiguration &&
      _vm.columnConfiguration.jibCrane.placement == 'RIGHT',
  }},[_c('div',{class:{ sides: true, 'two-columns': _vm.sides.length <= 2 }},_vm._l((_vm.sides),function(side){return _c('div',{key:side,class:_vm.columnConfiguration && _vm.columnConfiguration.jibCrane
          ? 'side mx-5'
          : 'side',style:(side == 'REAR' && _vm.sides.length > 2
          ? 'padding-right: 100px; border-right: 1px solid rgba(0, 0, 0, 0.6);'
          : side == 'LEFT'
            ? 'margin-left: 25px;'
            : '')},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t("columnside." + side)))]),(!_vm.$store.getters['projects/disabled'])?_c('div',{staticClass:"controls"},[_c('div',{staticClass:"resize",attrs:{"variant":"link"},on:{"click":function($event){return _vm.$emit('changeHeightOfMediacolumn', 'plus')}}},[_vm._v("＋")]),_c('div',{staticClass:"resize",attrs:{"variant":"link"},on:{"click":function($event){return _vm.$emit('changeHeightOfMediacolumn', 'minus')}}},[_vm._v("－")])]):_vm._e(),_c('div',{ref:"columns",refInFor:true,staticClass:"column",style:({
          height: ((_vm.columnConfiguration.height) + "px"),
          '--url-m': ("url('/img/column/" + _vm.columnImg + "_middle.png')"),
          '--url-l': ("url('/img/column/" + _vm.columnImg + "_lower.png')"),
          '--url-h': ("url('/img/column/" + _vm.columnImg + "_upper.png')"),
          '--module-width': (_vm.moduleWidth + "px"),
          '--width': ((_vm.columnType.widthX) + "px"),
        }),on:{"dragenter":function($event){return $event.preventDefault()},"dragover":function($event){return _vm.onDragOver($event, side)},"dragleave":_vm.onDragLeave,"drop":_vm.onDrop,"dragend":function($event){return _vm.$emit('dragEnd', $event)}}},[_vm._l((_vm.placements.concat( [_vm.hoverPlacement]).filter(
            function (p) { return p && p.side == side; }
          )),function(p){return _c('div',{key:p.id + p.gridIndex,staticClass:"module",class:{
            hover: p == _vm.hoverPlacement,
            invalid: _vm.isInvalid(p),
            empty: p.automatic,
            isEmpty: p.module.type == 'EMPTY',
            selected: p.id == _vm.selectedPlacement
          },style:({
            height: (((p.module.slotHeight || 1) * 125) + "px"),
            bottom: ((p.gridIndex * 125) + "px"),
            opacity:
              p.id == ((_vm.dragItem && _vm.dragItem.placement) || {}).id ||
                (p == _vm.hoverPlacement && !_vm.forbiddenToDrop)
                ? '0'
                : null,
            '--img-url': ("url('/img/modules/empty_module_" + _vm.emptyModuleImg + ".png')"),
          }),attrs:{"id":p.id.toString(),"draggable":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('selectPlacement', p.id, $event.currentTarget)},"dragstart":function($event){return _vm.onDragStart($event, p)},"dragenter":function($event){$event.preventDefault();}}},[(p.module.type == 'EMPTY')?_c('div',{staticClass:"empty"}):_c('img',{attrs:{"src":((_vm.moduleImageUrl(p.module)) + "_flat")}}),(
              p == _vm.hoverPlacement &&
              _vm.isInvalid(p) &&
              !_vm.positionIsIdenticalWithPlacement(p)
            )?_c('b-tooltip',{attrs:{"no-fade":"","variant":"danger","target":p.id.toString(),"show":true}},[_vm._v("\n            "+_vm._s(_vm.$t("configuration.invalidPlacementCollision"))+"\n          ")]):_vm._e()],1)}),_vm._l((_vm.columnConfiguration.height / 125),function(i){return _c('div',{key:i,staticClass:"measure",style:({ bottom: i * 125 + 'px' })},[_vm._v(_vm._s(i * 125)+" mm")])}),(
            side == 'FRONT' &&
            _vm.columnConfiguration &&
            _vm.columnConfiguration.jibCrane
          )?_c('div',{staticClass:"crane",style:({
            height: _vm.jibCraneSpan + 'px',
            bottom: _vm.columnConfiguration.jibCrane.height + 'px',
          })},[_c('div',{class:_vm.columnConfiguration.jibCrane.placement == 'LEFT'
                ? 'edit-left-jib-crane'
                : ''})]):_vm._e()],2)])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }